<template>
    <div>
        <SettingsCardTitle>
            {{ __('actions.edit_thing', {thing: __('store.document_types.' + documentType)}) }}
            <template v-slot:subtitle>
                {{ __('store.customize_legal_document') }}
            </template>
        </SettingsCardTitle>

        <!-- TODO: fix min height -->
        <RichEditor :min-height-px="200" v-model="document"/>

        <div class="d-flex flex-row gap-2 mt-10">
            <SaveAndEnableButton :disabled="text === document" @click="save"/>
            <div>
                <Link :href="$route('store.edit.legal', store.id)"
                      as="button"
                      class="btn btn-secondary"
                      @click="preventLeaveOnUnsavedChanges"
                >
                    <i class="fas fa-times"/>
                    {{ __('actions.abort') }}
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from "@pages/Stores/Edit/Nav/Navigation.vue";
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import RichEditor from "@components/RichTextEditor/RichEditor.vue";
import FormGroup from "@components/Form/FormGroup.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import BackButton from "@components/BackButton.vue";
import { Link } from '@inertiajs/vue2';

export default {
    layout: Navigation,

    components: {BackButton, SaveAndEnableButton, DividerDotted, FormGroup, RichEditor, SettingsCardTitle, Link},

    props: {
        store: Object,
        text: String,
        documentType: String
    },

    data() {
        return {
            document: this.text
        }
    },

    methods: {
        save() {
            this.$inertia.put(this.$route('store.edit.legal.document.save', [this.store.id, this.documentType]), {
                text: this.document
            })
        },

        preventLeaveOnUnsavedChanges(e) {
            if (this.document !== this.text) {
                if (confirm(__('questions.continue_with_unsaved_changes'))) {
                    return;
                }

                e.preventDefault();
            }
        }
    }
}
</script>
